import { apiFetch } from '../utils/apiClient';

/**
 * Fetch current user information from /users/me endpoint
 * @returns {Promise<{ID: string, Email: string, DataProviderID: string, DataProviderName: string}>}
 */
export const fetchCurrentUser = async () => {
  return apiFetch('/api/v1/users/me', {
    method: 'GET'
  });
};


